// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getCountryById } from 'app/constants/enums/Country/main';

/* eslint-disable max-len */
export const ABW = getCountryById('ABW');
export const AFG = getCountryById('AFG');
export const AGO = getCountryById('AGO');
export const AIA = getCountryById('AIA');
export const ALA = getCountryById('ALA');
export const ALB = getCountryById('ALB');
export const AND = getCountryById('AND');
export const ARE = getCountryById('ARE');
export const ARG = getCountryById('ARG');
export const ARM = getCountryById('ARM');
export const ASM = getCountryById('ASM');
export const ATA = getCountryById('ATA');
export const ATF = getCountryById('ATF');
export const ATG = getCountryById('ATG');
export const AUS = getCountryById('AUS');
export const AUT = getCountryById('AUT');
export const AZE = getCountryById('AZE');
export const BDI = getCountryById('BDI');
export const BEL = getCountryById('BEL');
export const BEN = getCountryById('BEN');
export const BES = getCountryById('BES');
export const BFA = getCountryById('BFA');
export const BGD = getCountryById('BGD');
export const BGR = getCountryById('BGR');
export const BHR = getCountryById('BHR');
export const BHS = getCountryById('BHS');
export const BIH = getCountryById('BIH');
export const BLM = getCountryById('BLM');
export const BLR = getCountryById('BLR');
export const BLZ = getCountryById('BLZ');
export const BMU = getCountryById('BMU');
export const BOL = getCountryById('BOL');
export const BRA = getCountryById('BRA');
export const BRB = getCountryById('BRB');
export const BRN = getCountryById('BRN');
export const BTN = getCountryById('BTN');
export const BVT = getCountryById('BVT');
export const BWA = getCountryById('BWA');
export const CAF = getCountryById('CAF');
export const CAN = getCountryById('CAN');
export const CCK = getCountryById('CCK');
export const CHE = getCountryById('CHE');
export const CHL = getCountryById('CHL');
export const CHN = getCountryById('CHN');
export const CIV = getCountryById('CIV');
export const CMR = getCountryById('CMR');
export const COD = getCountryById('COD');
export const COG = getCountryById('COG');
export const COK = getCountryById('COK');
export const COL = getCountryById('COL');
export const COM = getCountryById('COM');
export const CPV = getCountryById('CPV');
export const CRI = getCountryById('CRI');
export const CUB = getCountryById('CUB');
export const CUW = getCountryById('CUW');
export const CXR = getCountryById('CXR');
export const CYM = getCountryById('CYM');
export const CYP = getCountryById('CYP');
export const CZE = getCountryById('CZE');
export const DEU = getCountryById('DEU');
export const DJI = getCountryById('DJI');
export const DMA = getCountryById('DMA');
export const DNK = getCountryById('DNK');
export const DOM = getCountryById('DOM');
export const DZA = getCountryById('DZA');
export const ECU = getCountryById('ECU');
export const EGY = getCountryById('EGY');
export const ERI = getCountryById('ERI');
export const ESH = getCountryById('ESH');
export const ESP = getCountryById('ESP');
export const EST = getCountryById('EST');
export const ETH = getCountryById('ETH');
export const FIN = getCountryById('FIN');
export const FJI = getCountryById('FJI');
export const FLK = getCountryById('FLK');
export const FRA = getCountryById('FRA');
export const FRO = getCountryById('FRO');
export const FSM = getCountryById('FSM');
export const GAB = getCountryById('GAB');
export const GBR = getCountryById('GBR');
export const GEO = getCountryById('GEO');
export const GGY = getCountryById('GGY');
export const GHA = getCountryById('GHA');
export const GIB = getCountryById('GIB');
export const GIN = getCountryById('GIN');
export const GLP = getCountryById('GLP');
export const GMB = getCountryById('GMB');
export const GNB = getCountryById('GNB');
export const GNQ = getCountryById('GNQ');
export const GRC = getCountryById('GRC');
export const GRD = getCountryById('GRD');
export const GRL = getCountryById('GRL');
export const GTM = getCountryById('GTM');
export const GUF = getCountryById('GUF');
export const GUM = getCountryById('GUM');
export const GUY = getCountryById('GUY');
export const HKG = getCountryById('HKG');
export const HMD = getCountryById('HMD');
export const HND = getCountryById('HND');
export const HRV = getCountryById('HRV');
export const HTI = getCountryById('HTI');
export const HUN = getCountryById('HUN');
export const IDN = getCountryById('IDN');
export const IMN = getCountryById('IMN');
export const IND = getCountryById('IND');
export const IOT = getCountryById('IOT');
export const IRL = getCountryById('IRL');
export const IRN = getCountryById('IRN');
export const IRQ = getCountryById('IRQ');
export const ISL = getCountryById('ISL');
export const ISR = getCountryById('ISR');
export const ITA = getCountryById('ITA');
export const JAM = getCountryById('JAM');
export const JEY = getCountryById('JEY');
export const JOR = getCountryById('JOR');
export const JPN = getCountryById('JPN');
export const KAZ = getCountryById('KAZ');
export const KEN = getCountryById('KEN');
export const KGZ = getCountryById('KGZ');
export const KHM = getCountryById('KHM');
export const KIR = getCountryById('KIR');
export const KNA = getCountryById('KNA');
export const KOR = getCountryById('KOR');
export const KWT = getCountryById('KWT');
export const LAO = getCountryById('LAO');
export const LBN = getCountryById('LBN');
export const LBR = getCountryById('LBR');
export const LBY = getCountryById('LBY');
export const LCA = getCountryById('LCA');
export const LIE = getCountryById('LIE');
export const LKA = getCountryById('LKA');
export const LSO = getCountryById('LSO');
export const LTU = getCountryById('LTU');
export const LUX = getCountryById('LUX');
export const LVA = getCountryById('LVA');
export const MAC = getCountryById('MAC');
export const MAF = getCountryById('MAF');
export const MAR = getCountryById('MAR');
export const MCO = getCountryById('MCO');
export const MDA = getCountryById('MDA');
export const MDG = getCountryById('MDG');
export const MDV = getCountryById('MDV');
export const MEX = getCountryById('MEX');
export const MHL = getCountryById('MHL');
export const MKD = getCountryById('MKD');
export const MLI = getCountryById('MLI');
export const MLT = getCountryById('MLT');
export const MMR = getCountryById('MMR');
export const MNE = getCountryById('MNE');
export const MNG = getCountryById('MNG');
export const MNP = getCountryById('MNP');
export const MOZ = getCountryById('MOZ');
export const MRT = getCountryById('MRT');
export const MSR = getCountryById('MSR');
export const MTQ = getCountryById('MTQ');
export const MUS = getCountryById('MUS');
export const MWI = getCountryById('MWI');
export const MYS = getCountryById('MYS');
export const MYT = getCountryById('MYT');
export const NAM = getCountryById('NAM');
export const NCL = getCountryById('NCL');
export const NER = getCountryById('NER');
export const NFK = getCountryById('NFK');
export const NGA = getCountryById('NGA');
export const NIC = getCountryById('NIC');
export const NIU = getCountryById('NIU');
export const NLD = getCountryById('NLD');
export const NOR = getCountryById('NOR');
export const NPL = getCountryById('NPL');
export const NRU = getCountryById('NRU');
export const NZL = getCountryById('NZL');
export const OMN = getCountryById('OMN');
export const PAK = getCountryById('PAK');
export const PAN = getCountryById('PAN');
export const PCN = getCountryById('PCN');
export const PER = getCountryById('PER');
export const PHL = getCountryById('PHL');
export const PLW = getCountryById('PLW');
export const PNG = getCountryById('PNG');
export const POL = getCountryById('POL');
export const PRI = getCountryById('PRI');
export const PRK = getCountryById('PRK');
export const PRT = getCountryById('PRT');
export const PRY = getCountryById('PRY');
export const PSE = getCountryById('PSE');
export const PYF = getCountryById('PYF');
export const QAT = getCountryById('QAT');
export const REU = getCountryById('REU');
export const ROU = getCountryById('ROU');
export const RUS = getCountryById('RUS');
export const RWA = getCountryById('RWA');
export const SAU = getCountryById('SAU');
export const SDN = getCountryById('SDN');
export const SEN = getCountryById('SEN');
export const SGP = getCountryById('SGP');
export const SGS = getCountryById('SGS');
export const SHN = getCountryById('SHN');
export const SJM = getCountryById('SJM');
export const SLB = getCountryById('SLB');
export const SLE = getCountryById('SLE');
export const SLV = getCountryById('SLV');
export const SMR = getCountryById('SMR');
export const SOM = getCountryById('SOM');
export const SPM = getCountryById('SPM');
export const SRB = getCountryById('SRB');
export const SSD = getCountryById('SSD');
export const STP = getCountryById('STP');
export const SUR = getCountryById('SUR');
export const SVK = getCountryById('SVK');
export const SVN = getCountryById('SVN');
export const SWE = getCountryById('SWE');
export const SWZ = getCountryById('SWZ');
export const SXM = getCountryById('SXM');
export const SYC = getCountryById('SYC');
export const SYR = getCountryById('SYR');
export const TCA = getCountryById('TCA');
export const TCD = getCountryById('TCD');
export const TGO = getCountryById('TGO');
export const THA = getCountryById('THA');
export const TJK = getCountryById('TJK');
export const TKL = getCountryById('TKL');
export const TKM = getCountryById('TKM');
export const TLS = getCountryById('TLS');
export const TON = getCountryById('TON');
export const TTO = getCountryById('TTO');
export const TUN = getCountryById('TUN');
export const TUR = getCountryById('TUR');
export const TUV = getCountryById('TUV');
export const TWN = getCountryById('TWN');
export const TZA = getCountryById('TZA');
export const UGA = getCountryById('UGA');
export const UKR = getCountryById('UKR');
export const UMI = getCountryById('UMI');
export const URY = getCountryById('URY');
export const USA = getCountryById('USA');
export const UZB = getCountryById('UZB');
export const VAT = getCountryById('VAT');
export const VCT = getCountryById('VCT');
export const VEN = getCountryById('VEN');
export const VGB = getCountryById('VGB');
export const VIR = getCountryById('VIR');
export const VNM = getCountryById('VNM');
export const VUT = getCountryById('VUT');
export const WLF = getCountryById('WLF');
export const WSM = getCountryById('WSM');
export const XKX = getCountryById('XKX');
export const YEM = getCountryById('YEM');
export const ZAF = getCountryById('ZAF');
export const ZMB = getCountryById('ZMB');
export const ZWE = getCountryById('ZWE');
/* eslint-enable max-len */
